import React from "react";
import { Link } from "react-router-dom";

import S1 from "../img/services/1.jpg";
import S2 from "../img/services/2.png";
import S3 from "../img/services/3.jpg";
import S4 from "../img/services/4.png";

const ServiceList = [
    {
        link: "/local-moving",
        name: "Local Moving",
        img: S1,
        descrip: "Our local moving services ensure a stress-free experience with efficient planning, packing, and transportation."
    },
    {
        link: "/long-distance-moving",
        name: "Long Distance Moving",
        img: S2,
        descrip: "Long-distance moves are made easy with our expert team. We offer professional packing, secure transport..."
    },
    {
        link: "/commercial-moving",
        name: "Commercial Moving",
        img: S3,
        descrip: "Relocate your business with minimal downtime using our specialized commercial moving services. From office ..."
    },
    {
        link: "/full-packing",
        name: "Full Packing",
        img: S4,
        descrip: "Our secure storage solutions provide a safe space for your belongings, whether for short-term or long-term needs."
    },
];

const ServicesList = () => {
    return (
        <section className="service_section layout_padding">
            <div className="service_container">
                <div className="container ">
                    <div className="heading_container">
                        <h2> Our <span>Services</span> </h2>
                    </div>
                    <div className="row">
                        {ServiceList.map((list, index) => (
                            <div className="col-md-3" key={index}>
                                <div className="box">
                                    <div className="img-box">
                                        <Link to={list.link}>
                                            <img src={list.img} alt={list.name} />
                                        </Link>
                                    </div>
                                    <div className="detail-box">
                                        <h5><Link to={list.link}>{list.name}</Link></h5>
                                        <p>{list.descrip}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ServicesList;